import React, {useState} from 'react';
import { UserContext } from '../../contexts/userContext.js';
import './App.css';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import LoginPage from '../../pages/LoginPage.js';
import HomePage from '../../pages/HomePage.js';
import AuthenticatedPing from '../../pages/AuthenticatedPing.js';
import { logoutUser } from '../../api/auth.js';
import AuthenticatedWeeklyPrice from '../../pages/AuthenticatedWeeklyPrice.js'; //Added
import Companies from '../../components/Pages/Companies.js'; //Added
import Filter from '../../components/Pages/Filter.js'; //Added
import {Helmet} from "react-helmet";
import {background_color, brand_text_class} from "../../settings.js";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
const ACCESS_TOKEN = 'access_token'

function App() {
  const [user, setUser] = useState(null);
  const isUserLoggedIn = () => {
    return user != null;
  }

  const logout = (event) => {
    event.preventDefault();
    logoutUser();
    setUser(null);
  }

  function remainLogIn(){
    window.localStorage.setItem('user', user);
    if (window.localStorage.getItem(ACCESS_TOKEN) == null){
        window.localStorage.removeItem('user');
    }else{
        if (user  == null){
        setUser(window.localStorage.getItem('user'))
        }
    }
  }
  remainLogIn()
    const bg = {
        'background-color': background_color,
        'height':'100%',
        'box-sizing': 'border-box',
        'background': background_color
    }
  /* referring to <UserContext.Provider value={{user, setUser, isUserLoggedIn}}> and other instances.
  * since the values are stored as variables in context, it's not necessary to escape the values for XSS-sake.
  */
//                  {isUserLoggedIn()?
//                  <Nav.Link as={Link} to="/">Home</Nav.Link>
//                  :
//                  <Nav.Link as={Link} ></Nav.Link>
//                  }
  return (
    <div className="App" style={bg}>

    <Helmet>
        {isUserLoggedIn() ?
            <title> 清水経済研究所 </title>
            :
            <title> Shimizu.FI </title>
        }
    </Helmet>
      <UserContext.Provider value={{user, setUser, isUserLoggedIn}}>
        <Router>
          <Container>
            <Navbar sticky="top" bg="dark" expand="lg" class="navbar-nav ml-auto" variant="dark">
              <Navbar.Brand href="#home">
                  {isUserLoggedIn() ?
                      <img
                        src="/shamrock_7572374.png"
                        width="30"
                        height="30"
                        className="d-inline-block align-top"
                        alt="☘️"
                      />
                      :
                      <div></div>
                  }
                  {isUserLoggedIn() ?
                      <a href="#home" class={brand_text_class} >&nbsp;清水経済研究所</a>
                      :
                      <a href="#home" class={brand_text_class} style={{"font-family": "monospace"}}>Shimizu.FI</a>
                  }
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                  {isUserLoggedIn() ?
                      <Nav.Link as={Link} to="/companies">銘柄一覧</Nav.Link>//Companies list
                      :
                      <Nav.Link as={Link} ></Nav.Link>
                  }
                  {isUserLoggedIn() ?
                      <Nav.Link as={Link} to="/filter">フィルタ</Nav.Link> //Recommendations
                      :
                      <Nav.Link as={Link} ></Nav.Link>
                  }
                </Nav>
                <Nav className="justify-content-end">
                  {//<Nav.Link as={Link} to="/ping">Ping</Nav.Link>
                  }
                  { isUserLoggedIn() ?
                    <Nav.Link as={Link} onClick={logout}>Logout ({window.localStorage.getItem('username')})</Nav.Link>
                    :
                    <Nav.Link as={Link} to="/login">Login</Nav.Link>
                  }
                </Nav>
              </Navbar.Collapse>
            </Navbar>
            <Switch>
                <Route exact path="/login">
                  <LoginPage/>
                </Route>
                <Route exact path="/ping">
                  <AuthenticatedPing/>
                </Route>
                <Route exact path="/companies">
                  <Companies/>
                </Route>
                <Route exact path="/filter">
                  <Filter/>
                </Route>
                <Route exact path="/weekly_price/">
                  <AuthenticatedWeeklyPrice/>
                </Route>
                <Route path="/weekly_price/:code">
                  <AuthenticatedWeeklyPrice/>
                </Route>
                <Route exact path="/">
                  <HomePage/>
                </Route>
            </Switch>
          </Container>
        </Router>
      </UserContext.Provider>
    </div>
  );
}

export default App;
